// CUSTOM JS.

// Add an optimized resize event.
(function() {
	var throttle = function(type, name, obj) {
		obj = obj || window;
		var running = false;
		var func = function() {
			if (running) { return; }
			running = true;
				requestAnimationFrame(function() {
					obj.dispatchEvent(new CustomEvent(name))
					running = false;
			});
		};
		obj.addEventListener(type, func)
	};

	throttle("resize", "optimizedResize")
})();
// Usage example: Recalculate on resize
// window.addEventListener("optimizedResize", function() {
// 	window.setTimeout( ()=>{
// 		console.log( 'optimized resize called!')
// 	}, 100)
// });




// Initial setup on Load.
// In order of need.
document.addEventListener('DOMContentLoaded', (event) => {
	console.log( 'JS parent theme loaded.' )

	const html = document.querySelector('html');
	const body = document.querySelector('body');
	html.classList.remove('no-js')
	html.classList.add('js')


	// When the last child of #main .entry-content has a background, remove the top margin from the footer.
	const lastContentItem = document.querySelector('#main .entry-content > :last-child');
	const siteFooter = document.querySelector('footer.wp-block-template-part');
	if (lastContentItem && siteFooter) {
		if (lastContentItem.classList.contains('has-background')) {
			siteFooter.classList.add('no-margin-top');
		}
	}

	// Add Button icons
	const leesMeerButtons = document.querySelectorAll('.wp-block-button.is-style-arrow-right .wp-block-button__link, .wp-block-button.is-style-arrow-right .wp-element-button')
	if (leesMeerButtons) {
		leesMeerButtons.forEach(element => {
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
			let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
			use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#inz_arrow_right');
			svg.append(use)
			svg.classList.add('svg-icon')
			svg.setAttribute('aria-hidden', 'true')
			element.append(svg)
		})
	}
})



